module.exports = __webpack_public_path__ + "img/icons8-mapa-end-24.df45983c.svg";